import { Component, OnInit } from '@angular/core';
import { ISeasonWeek } from '../models/ISeasonWeek';
import { IOrgSeasonWeek } from '../models/IOrgSeasonWeek';
import { IOrg } from  '../models/IOrg';
import { ISeason } from '../models/ISeason';
import { IWeek } from '../models/IWeek';
import { OrgSeasonWeekService } from '../services/orgseasonweek.service';

@Component({
  selector: 'app-orgseasonweek',
  templateUrl: './app-orgseasonweek.component.html',
  styleUrls: ['./app-orgseasonweek.component.scss']
})
export class AppOrgSeasonWeekComponent implements OnInit {

  public model: IOrgSeasonWeek = { season: null, seasonType:null, week: null, org: null };
  public orgs: IOrg[];
  public disabled: boolean = false;
  public error: any;
  public seasons: ISeason[];
  public weeks: IWeek[];

  constructor(private service: OrgSeasonWeekService) {

  }
  ngOnInit() {
    this.orgs = this.service.orgs;
    this.model.org = this.orgs[0];
    this.service.updateOrg(this.model.org);
    this.getSeasons();
  }

  setOrg(org: IOrg) {
    this.service.updateOrg(org);
    this.model.org = org;
    
  }

  setWeek(week: IWeek) {
    this.service.updateWeek(week);
    this.model.week = week;
  }

  setSeason(season: ISeason) {
    this.service.updateSeason(season);
    this.model.season = season;
    this.getWeeks();
  }


  getSeasons() {
    this.service.getSeasons()
      .subscribe(result => {
        this.seasons = result as ISeason[];
        this.seasons.sort((a, b) => b.name- a.name);
        this.model.season = this.seasons[0];
        this.service.updateSeason(this.model.season);
        this.getWeeks();
      });
  }

  private getWeeks() {
    //var season = {name: this.model.season} as ISeason;
    this.service.getWeeks(this.model.season)
      .subscribe(result => {
        this.weeks = result as IWeek[];
        this.setPlayOffWeek(this.weeks);
        this.weeks.sort((a, b) => b.name - a.name);
        this.model.week = this.weeks[0];
        this.service.updateWeek(this.model.week);
      });
  }

  private setPlayOffWeek(weeks: IWeek[]) {
    weeks.forEach(week => {
      if (week.name > 18)
        week.isPlayoff = true;
      else
        week.isPlayoff = false;
      if (week.name == 19)
        week.displayName = "Playoff - Wildcard";
      else if (week.name == 20)
        week.displayName = "Playoff - Division";
      else if (week.name == 21)
        week.displayName = "Playoff - Championship";
      else if (week.name >= 22)
        week.displayName = "Playoff - Superbowl";
      else
        week.displayName = week.name.toString();
    });

  }

  


}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/app-orgseasonweek/app-orgseasonweek.component.ts